import React from 'react'
import { MapNode } from '../lib/types'
import { AlertTriangle } from 'lucide-react'

interface Props {
  nodes: MapNode[]
  onFocus: (id: string) => void
  selectedId?: string | null
}

export function KnotList({ nodes, onFocus, selectedId }: Props) {
  const openKnots = [...nodes]
    .filter(n => n.uncertainty === 'high' || n.uncertainty === 'critical' || !n.next_question || !n.evidence_need)
    .sort((a, b) => {
      const score = (n: MapNode) => (n.uncertainty === 'critical' ? 100 : n.uncertainty === 'high' ? 70 : 40) +
        (!n.next_question ? 20 : 0) + (!n.evidence_need ? 15 : 0)
      return score(b) - score(a)
    })

  if (openKnots.length === 0) {
    return (
      <div className="text-sm text-bench-resolved px-3 py-4 bg-white rounded border">
        All current knots have a next question and evidence need logged.<br />Good repair work.
      </div>
    )
  }

  return (
    <div className="space-y-1.5 max-h-[420px] overflow-auto pr-1">
      {openKnots.slice(0, 18).map(node => {
        const urgent = node.uncertainty === 'critical' || node.uncertainty === 'high'
        return (
          <button
            key={node.id}
            onClick={() => onFocus(node.id)}
            className={`w-full text-left px-3 py-2 rounded border text-sm transition flex gap-2 items-start
              ${selectedId === node.id ? 'border-bench-accent bg-amber-50' : 'border-slate-200 hover:border-slate-300 bg-white'}`}
          >
            <div className="pt-0.5">
              {urgent && <AlertTriangle size={15} className="text-bench-knot" />}
            </div>
            <div className="min-w-0">
              <div className="font-medium text-bench-ink line-clamp-2">{node.label}</div>
              <div className="text-[11px] text-slate-500 mt-0.5 flex gap-2">
                {node.uncertainty && <span className="uppercase tracking-widest">{node.uncertainty}</span>}
                {!node.next_question && <span className="text-violet-600">no next question</span>}
                {!node.evidence_need && <span className="text-sky-600">no evidence target</span>}
              </div>
            </div>
          </button>
        )
      })}
      {openKnots.length > 18 && (
        <div className="text-xs text-center text-slate-400 pt-1">+{openKnots.length - 18} more unrepaired</div>
      )}
    </div>
  )
}
